import React from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import 'font-awesome/css/font-awesome.min.css';


class QuestionAudioPlayer extends React.Component{

    constructor(props){
        super(props);

        this.state = {
            play:false,
            status:false,
            dummyInput:1,
            count:50,
            countTimer:'00:50',
            zeit:this.props.timer,
            aUrl:this.props.questionAudio.audioUrl,
            afile:this.props.questionAudio.audio,

        };
    }
    componentDidMount() {
     /*   console.log('hi mount')*/
    }
    componentDidUpdate(){

      /*  console.log('in update')*/
    }
    componentWillReceiveProps(newProps) {
      /*  console.log(newProps.timerUpdated)
        console.log(newProps.questionAudio.audio)
        console.log('next')*/
        this.setState({zeit: newProps.timerUpdated});
        this.setState({aUrl: newProps.questionAudio.audioUrl});
        this.setState({afile: newProps.questionAudio.audio});
        /*this.props.questionAudio.audio.pause()*/
       /* console.log(this.state.play)*/
       /* this.setState({play:false})*/
        /*this.togglePlay(newProps.questionAudio.audio)*/
        /*this.setState({aUrl: newProps.questionAudio.audioUrl},()=>{
       /!*     console.log(this.state.aUrl)
           if(this.state.aUrl==""){
               this._playTimer();
           }else{
               this._stopTimer()
               this.togglePlay(this.props.questionAudio.audio)
           }*!/
        });*/
    }

    togglePlay = (audio) => {
        this.setState({ play: !this.state.play }, () => {
            if(this.state.play){
                audio.play();
                this._playTimer();
            }else{
                audio.pause();
            }
        });
    };
    _playTimer(){
        clearInterval(this.interval);
        this.interval = setInterval(() => {
           /* console.log('hi')*/
            let result = this._startTimer(this.state.zeit);
            this.setState({zeit:result});
        },1000)
    }
    _stopTimer(){
        clearInterval(this.interval);
    }
    _start(index){
       setTimeout(()=> {
          /* console.log(index)*/
           if(this.props.questionAudio.audio=="" &&
               index!="14"){
               this._playTimer();
           }else{
               this._stopTimer();
              /* this.state.afile.pause()*/
               this.setState({play:false})
           }
        },100);
     /*   if(this.state.aUrl===""){*/

    }

    startCountdown(time,minutes, seconds){
        let tt=time.split(":");
        let totalSec=tt[0]*60+tt[1]*1;
        if(totalSec > 0) {
            --totalSec;
            minutes = parseInt(totalSec / 60, 10)
            seconds = parseInt(totalSec % 60, 10);

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;


           /* console.log(minutes + ':' + seconds);*/
            return minutes + ':' + seconds; //00:44
        }
    }
    _startTimer(zeit){
        let minutes, seconds;
        const changedTimer = this.startCountdown(zeit, minutes, seconds);
        if(changedTimer) {
            this.props.updateTimer(changedTimer);
            return changedTimer;
        }else{
            this.setState({ play: !this.state.play });
            this._stopTimer();
        }
    }

    render(){
        /*console.log(this.props.paramFrame.brand)*/
        const isIE = /*@cc_on!@*/false || !!document.documentMode;
        let progressVal=0;
        let server_url = window.location.origin;
        let play_url,pause_url;
        if(process.env.NODE_ENV === "development"){
            play_url = "https://sprachtest.local.de/themes/custom/sprachtest_frontend/images/play.svg";
            pause_url = "https://sprachtest.local.de/themes/custom/sprachtest_frontend/images/pause.svg";
        }else {
            play_url = server_url + "/themes/custom/sprachtest_frontend/images/play.svg";
            pause_url = server_url + "/themes/custom/sprachtest_frontend/images/pause.svg";
        }
        //console.log(play_url)
        if(this.props.questionAudio.audio.duration) {
            progressVal = Math.floor(
                (this.props.questionAudio.audio.currentTime / this.props.questionAudio.audio.duration) * 100
            )
        }
        if(this.props.questionAudio.audioUrl!="") {
            return (
                <div className="audioPlayer">
                    <div className="questionAudio centered">
                        <div className="player" onClick={this.togglePlay.bind(this, this.props.questionAudio.audio)}>
                            <CircularProgressbarWithChildren
                                value={progressVal}
                                strokeWidth={5}
                                background={true}
                                 backgroundPadding={3}
                                styles={buildStyles({
                                    pathColor: this.props.paramFrame.brand=='zeit'? '#0088A0': '#fc7952',
                                    textColor: '#f88',
                                    trailColor: '#fff',
                                    backgroundColor: '#fff',
                                })}
                                text={this.state.play ?
                                    <tspan dy={isIE ? -10 : 0} className="audioIcon pause"><img style={{width:70}}  src={pause_url} /></tspan> :
                                    <tspan dy={isIE ? -10 : 0} className="audioIcon play"><img  style={{width:70}} src={play_url} /></tspan>
                                }
                            >
                                {this.state.play ?
                                    <span className="audioIcon pause"><img style={{width:70}}  src={pause_url} /></span> :
                                    <span className="audioIcon play"><img  style={{width:70}} src={play_url} /></span>
                                }

                            </CircularProgressbarWithChildren>

                        </div>
                    </div>
                </div>
            );
        }else {
            return (<div className="audioPlayer"></div>);
        }
    }
}
export default QuestionAudioPlayer;
